module.exports = __webpack_public_path__ + "img/goog.97cbcfe4.svg";